import { createFileRoute } from '@tanstack/react-router';
import { EditChoice } from '../../features/choices/edit';
import { choicesEditGuard } from '@bmwe/ui';

export const Route = createFileRoute('/auswahlfelder/$choiceId_/bearbeiten')({
  component: EditChoice,
  beforeLoad: choicesEditGuard,
});

export const EditChoiceRoute = Route;
